import { formatDate } from "../../../../../../helpers"
import { IPolicyUpdates } from "../../../../../../redux/policyCommon/policyCommon.types"


export const getEmailUpdateTemplate = (data: IPolicyUpdates, key: string) => {

    return(`
<div style="font-family: Arial, Helvetica, sans-serif; font-size: 14px; color: #333; line-height: 1.6;">
 

  <p>Hello ${data.customer_name},</p>

  <p>
    Please be advised that your <strong>Life Agents Errors &amp; Omissions</strong> policy
    is up for renewal on <strong>${formatDate(data.expiry_date)}</strong>.
    Below are the necessary details and instructions to proceed with the renewal.
  </p>

  <p><strong>Steps to renew your Life Agents E&amp;O Policy:</strong></p>

  <ol>
    <li>Complete the update form and calculate your renewal premium.</li>
    <li>
      E-transfer the payment to 
      <a href="mailto:accounts@aaxelinsurance.com">accounts@aaxelinsurance.com</a>
      (Please add your <strong>Policy #</strong> in the comments).
    </li>
    <li>Attach the payment proof in the form.</li>
  </ol>

  <p style="margin-bottom: 10px">
  <a
  href="${window.location.origin}/policy-updates/${key}"
  target="_blank"
  rel="noopener noreferrer"
  style="
    display: inline-block;
    background-color: #1976d2;
    color: #ffffff;
    text-decoration: none;
    padding: 12px 24px;
    border-radius: 4px;
    cursor: pointer;
    font-weight: 500;
    font-size: 1rem;
  "
>
  Update info &amp; Calculate Renewal Premium
</a>
</p>

  <p style="color: #b00020;">
    <strong>
      If we do not receive the completed form and payment before the renewal date,
      your policy will lapse, meaning no coverage.
    </strong>
  </p>

  <p>
    If you have any questions, please contact us at
    <strong>905-362-8080 ext. 385</strong>.
  </p>

  <p>
    Regards,<br/>
    Account Manager
  </p>
</div>
`

    )
}